import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AnimatedCounter from '../components/AnimatedCounter';
import PageTransition from '../components/PageTransition';
import SpotlightCard from '../components/SpotlightCard';

/* ============================================================
   6 FEATURED SERVICES (core offerings only)
   ============================================================ */
const services = [
  {
    id: 'tax',
    icon: (
      <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14,2 14,8 20,8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
      </svg>
    ),
    title: 'Tax Preparation & Planning',
    desc: 'Individual and business returns, multi-state filings, IRS representation, and proactive tax planning strategies.',
  },
  {
    id: 'accounting',
    icon: (
      <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 3v18h18"/>
        <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"/>
      </svg>
    ),
    title: 'Accounting & Bookkeeping',
    desc: 'Full-cycle bookkeeping, monthly close, AP/AR management, bank reconciliations, and GAAP-compliant reporting.',
  },
  {
    id: 'payroll',
    icon: (
      <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    ),
    title: 'Payroll Services',
    desc: 'End-to-end payroll processing, tax filings, multi-state compliance, direct deposit, and year-end reporting.',
  },
  {
    id: 'audits',
    icon: (
      <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 12l2 2 4-4"/>
        <circle cx="12" cy="12" r="10"/>
      </svg>
    ),
    title: 'Audit, Review & Compilation',
    desc: 'Independent assurance services for lenders, investors, and stakeholders. Financial statement audits, reviews, and compilations.',
  },
  {
    id: 'financial',
    icon: (
      <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 20V10"/>
        <path d="M18 20V4"/>
        <path d="M6 20v-4"/>
      </svg>
    ),
    title: 'CFO & Financial Advisory',
    desc: 'Part-time CFO leadership, financial modeling, budgeting, cash flow management, and investor reporting.',
  },
  {
    id: 'consulting',
    icon: (
      <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    title: 'Business Consulting',
    desc: 'M&A advisory, business valuations, financial projections, restructuring, and operational efficiency consulting.',
  },
  {
    id: 'formation',
    icon: (
      <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 21h18"/>
        <path d="M9 8h1"/>
        <path d="M9 12h1"/>
        <path d="M9 16h1"/>
        <path d="M14 8h1"/>
        <path d="M14 12h1"/>
        <path d="M14 16h1"/>
        <path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16"/>
      </svg>
    ),
    title: 'Entity Formation',
    desc: 'Corporate structuring, LLC formations, partnership agreements, and regulatory compliance advisory.',
  },
  {
    id: 'forensic',
    icon: (
      <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8"/>
        <line x1="21" y1="21" x2="16.65" y2="16.65"/>
        <line x1="11" y1="8" x2="11" y2="14"/>
        <line x1="8" y1="11" x2="14" y2="11"/>
      </svg>
    ),
    title: 'Forensic Accounting',
    desc: 'Fraud investigations, litigation support, economic damages calculation, and expert witness testimony.',
  },
  {
    id: 'salt',
    icon: (
      <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
        <circle cx="12" cy="10" r="3"/>
      </svg>
    ),
    title: 'State & Local Tax (SALT)',
    desc: 'Nexus studies, sales & use tax consulting, property tax appeals, and multi-state controversy.',
  },
  {
    id: 'wealth',
    icon: (
      <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
      </svg>
    ),
    title: 'Wealth & Estate Planning',
    desc: 'High-net-worth preservation, trust tax preparation, succession planning, and gift strategies.',
  },
  {
    id: 'rnd',
    icon: (
      <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 18h6"/>
        <path d="M10 22h4"/>
        <path d="M12 2v1"/>
        <path d="M12 7a5 5 0 0 1 5 5c0 2-1 3-2 4a3 3 0 0 0-1 2v2H10v-2a3 3 0 0 0-1-2c-1-1-2-2-2-4a5 5 0 0 1 5-5z"/>
      </svg>
    ),
    title: 'R&D Tax Credits',
    desc: 'Identification, documentation, and defense of research and development tax credits to minimize liabilities.',
  },
  {
    id: 'risk',
    icon: (
      <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
    ),
    title: 'SOC & Risk Advisory',
    desc: 'System and Organization Controls (SOC) 1, 2, and 3 examinations, IT audits, and readiness assessments.',
  },
];



function Home() {
  const [activeTab, setActiveTab] = useState('core');
  const displayServices = activeTab === 'core' ? services.slice(0, 6) : services.slice(6, 12);

  return (
    <PageTransition>
      {/* ── Hero Section ── */}
      <header className="byhw-hero" style={{padding:'120px 24px 100px'}}>
        <div style={{position:'relative', zIndex:1, maxWidth:800, margin:'0 auto'}}>
          <h1 style={{ whiteSpace: 'pre-line' }}>
            {'Advanced Tax Strategies\n& Elite Financial Advisory'}
          </h1>
          <p style={{
            fontSize: 'clamp(1rem, 2vw, 1.12rem)',
            color: 'rgba(255,255,255,0.75)',
            marginTop: 28,
            marginBottom: 44,
            lineHeight: 1.75,
            maxWidth: 620,
            marginLeft: 'auto',
            marginRight: 'auto',
            fontWeight: 400,
          }}>
            Delivering sophisticated tax planning, compliance, and accounting solutions to navigate complex regulatory landscapes. We empower high-net-worth individuals and enterprises to preserve wealth and maximize operational efficiency.
          </p>
          <div style={{display:'flex', gap:16, justifyContent:'center', alignItems:'center', flexWrap:'wrap'}}>
            <Link className="byhw-cta" to="/contact" style={{
              marginTop: 0, padding: '14px 36px', fontSize: '0.95rem',
            }}>Engage Our Firm</Link>
            <Link className="byhw-cta-outline" to="/why-us" style={{
              marginTop: 0, padding: '14px 36px', fontSize: '0.95rem',
            }}>Explore Credentials</Link>
          </div>
        </div>
      </header>

      {/* ── Trusted By & Technology Partners ── */}
      <div style={{
        background: 'var(--clr-white)',
        padding: '48px 24px',
        borderBottom: '1px solid var(--clr-border)',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: 1200, margin: '0 auto'}}>
          <p style={{
            fontSize: '0.85rem', color: 'var(--clr-gray-light)', fontWeight: 600, 
            textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '32px'
          }}>
            Trusted by Industry Leaders & Powered by Enterprise Infrastructure
          </p>
          <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '32px',
            opacity: 0.5, filter: 'grayscale(100%)', transition: 'opacity 0.3s'
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = '0.8'}
          onMouseLeave={e => e.currentTarget.style.opacity = '0.5'}>
            {/* Row 1: Tech Partners */}
            <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', columnGap: '56px', rowGap: '24px'}}>
              <div style={{fontSize:'1.6rem', fontWeight:800, fontFamily:'Segoe UI, Arial, sans-serif'}}>Microsoft</div>
              <div style={{fontSize:'1.7rem', fontWeight:700, fontFamily:'Arial, sans-serif', letterSpacing:'-0.03em'}}>amazon</div>
              <div style={{fontSize:'1.8rem', fontWeight:700, fontFamily:'Arial, sans-serif', letterSpacing:'-0.05em'}}>intuit <span style={{fontWeight:300}}>quickbooks</span></div>
              <div style={{fontSize:'1.6rem', fontWeight:800, fontFamily:'"Helvetica Neue", Helvetica, sans-serif'}}>Adobe</div>
            </div>
            {/* Row 2: Financial Partners */}
            <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', columnGap: '56px', rowGap: '24px'}}>
              <div style={{fontSize:'1.4rem', fontWeight:800, fontFamily:'Georgia, serif'}}>JPMorgan Chase & Co.</div>
              <div style={{fontSize:'1.2rem', fontWeight:800, fontFamily:'"Helvetica Neue", Helvetica, sans-serif', textTransform:'uppercase', letterSpacing:'0.05em', border:'2px solid', padding:'2px 6px', borderRadius:'4px'}}>American Express</div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Services ── */}
      <section className="byhw-section" id="services" style={{paddingTop:80, paddingBottom:40}}>
        <div style={{ textAlign: 'center' }}>
          <h2>Our Expertise</h2>
          <p style={{
            fontSize: '1rem', color: 'var(--clr-gray)', marginTop: 12,
            maxWidth: 520, marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.6,
          }}>
            Comprehensive capabilities spanning the entire financial lifecycle
          </p>
          <div role="tablist" style={{ marginTop: 40, display: 'flex', justifyContent: 'center', gap: 32, flexWrap: 'wrap' }}>
            <button 
              role="tab"
              aria-selected={activeTab === 'core'}
              className={`byhw-tab-btn ${activeTab === 'core' ? 'active' : ''}`}
              onClick={() => setActiveTab('core')}
            >
              Core Capabilities
            </button>
            <button 
              role="tab"
              aria-selected={activeTab === 'specialized'}
              className={`byhw-tab-btn ${activeTab === 'specialized' ? 'active' : ''}`}
              onClick={() => setActiveTab('specialized')}
            >
              Specialized Advisory
            </button>
          </div>
        </div>
        <ul role="tabpanel" className="byhw-services-list" style={{marginTop:48}}>
          {displayServices.map((s, i) => (
            <SpotlightCard key={s.id} service={s} index={i} />
          ))}
        </ul>
      </section>

      {/* ── Stats Bar ── */}
      <div className="byhw-stats-bar">
        <div className="byhw-stats-inner">
          <div className="byhw-stat-item">
            <div className="byhw-stat-number"><AnimatedCounter target={20} duration={2000} suffix="+" /></div>
            <div className="byhw-stat-label">Years of Experience</div>
          </div>
          <div className="byhw-stat-separator"></div>
          <div className="byhw-stat-item">
            <div className="byhw-stat-number"><AnimatedCounter target={100} duration={2500} suffix="+" /></div>
            <div className="byhw-stat-label">Clients Served</div>
          </div>
          <div className="byhw-stat-separator"></div>
          <div className="byhw-stat-item">
            <div className="byhw-stat-number"><AnimatedCounter target={50} duration={2000} /></div>
            <div className="byhw-stat-label">States Covered</div>
          </div>
          <div className="byhw-stat-separator"></div>
          <div className="byhw-stat-item">
            <div className="byhw-stat-number">24/7</div>
            <div className="byhw-stat-label">Client Support</div>
          </div>
        </div>
      </div>

      {/* ── CTA Banner ── */}
      <div style={{
        background: 'linear-gradient(135deg, var(--clr-navy) 0%, var(--clr-navy-deep) 100%)',
        padding: '64px 24px',
        textAlign: 'center',
      }}>
        <h2 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: 'clamp(1.5rem, 3vw, 2.2rem)',
          fontWeight: 700, color: 'var(--clr-white)', marginBottom: 16,
        }}>Ready to Get Started?</h2>
        <p style={{
          fontSize: '1rem', color: 'rgba(255,255,255,0.75)',
          maxWidth: 500, margin: '0 auto 28px', lineHeight: 1.6,
        }}>
          Contact us for a complimentary consultation. We will assess your needs and recommend the right approach.
        </p>
        <Link to="/contact" className="byhw-cta" style={{padding:'13px 36px', fontSize:'0.95rem'}}>
          Request a Consultation
        </Link>
      </div>
    </PageTransition>
  );
}

export default Home;